import axios from 'axios';
import { createBrowserHistory } from 'history';
import { default as qs, default as QueryString } from 'qs';
import {
  deleteLocalData,
  getAccessToken,
  getRefreshToken,
  removeAxiosHeaders,
  removeEmpty,
  setAccessToken,
  setAxiosHeaders,
  setRefreshToken,
  setRetailAccessToken,
  setRetailRefreshToken,
} from '../utils/helper';
import apiEndpoints from './apiEndPoints';

const configUrlEncoded = {
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
};

const history = createBrowserHistory({});
let isTokenrefreshing = false,
  retryReqestArray: any = [];
let userDataRequest: Promise<any> | null = null;

function onTokenRefresh(authorisationToken: any) {
  retryReqestArray.map((cb: any) => cb(authorisationToken));
}

axios.interceptors.response.use(
  (response) => {
    // window.console.log(response.status);
    return response;
  },
  (error) => {
    // window.console.log(error.response);
    if (error && error.response) {
      if (error.response.status === 401) {
        if (getAccessToken()) {
          if (getRefreshToken()) {
            if (!isTokenrefreshing) {
              removeAxiosHeaders();
              isTokenrefreshing = true;
              const params = {
                grant_type: 'refresh_token',
                refresh_token: getRefreshToken(),
              };
              axios
                .post(apiEndpoints.refreshToken, params)
                .then((response) => {
                  setRefreshToken(response.data.refresh_token);
                  setRetailRefreshToken(response.data.refresh_token);
                  setAccessToken(response.data.access_token);
                  setRetailAccessToken(response.data.access_token);
                  setAxiosHeaders();
                  onTokenRefresh(response.data.access_token);
                  window.location.reload();
                })
                .catch(() => {
                  removeAxiosHeaders();
                  deleteLocalData('accessToken');
                  deleteLocalData('refreshToken');
                  history.push('/');
                  window.location.reload();
                });
            }
            return new Promise((resolve) => {
              retryReqestArray.push((token: any) => {
                const originalRequest = error.config;
                originalRequest.headers.Authorization = `Bearer ${token}`;
                resolve(axios(originalRequest));
              });
            });
          } else {
            removeAxiosHeaders();
            deleteLocalData('accessToken');
            history.push('/');
            window.location.reload();
          }
        } else {
          removeAxiosHeaders();
          deleteLocalData('accessToken');
          deleteLocalData('refreshToken');
          // history.push('/');
          // window.location.reload();
        }
      }
      // if (error.response.status === 404) {
      //   history.push('/403');
      //   window.location.reload();

      // }
      // if (error.response.status >= 500) { history.push('/500'); window.location.reload(); }
    }
    return Promise.reject(error);
  }
);

axios.interceptors.request.use((request: any) => {
  let requestPlatform = 'web';
  try {
  } catch (e) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      requestPlatform = 'm-web';
    }
  }
  request.headers['X-REQUEST-PLATFORM'] = requestPlatform;
  request.headers['X-XSS-Protection'] = '1; mode=block';
  request.headers['X-Frame-Options'] = 'DENY';
  request.headers['X-Content-Type-Options'] = 'nosniff';
  request.headers['Referrer-Policy'] = 'strict-origin-when-cross-origin';
  if (request.data instanceof FormData) {
    delete request.headers['Content-Type'];
    delete request.headers['content-type'];
  } else if (!request.headers['Content-Type'] && !request.headers['content-type']) {
    request.headers['Content-Type'] = 'application/json';
  }
  request.headers['Strict-Transport-Security'] = 'max-age=63072000; includeSubDomains; preload';
  // request.headers['Content-Security-Policy'] = "default-src 'self'; script-src 'self' https://apis.google.com; style-src 'self' 'unsafe-inline'; img-src 'self' data:;";
  return request;
});

const api = {
  profile: {
    login: (credentials: any) => axios.post(apiEndpoints.authenticate, credentials).then((res) => res.data),
    logout: () => axios.post(apiEndpoints.logout).then((res) => res.data),
    googleLogin: (credentials: any) => axios.post(apiEndpoints.googleLogin, credentials).then((res) => res.data),
    microsoftLogin: (credentials: any) => axios.post(apiEndpoints.microsoftLogin, credentials).then((res) => res.data),
    ssoLogin: (params?: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.ssoInfo, { params: params, signal: signal }).then((res) => res.data),
    userData: (signal?: AbortSignal) => {
      if (!userDataRequest) {   userDataRequest = axios
          .get(apiEndpoints.userData, { signal: signal })
          .then((res) => res.data)
          .finally(() => {
            userDataRequest = null;
          });
      }
      return userDataRequest;
    },
    requestOTP: (data: object) => axios.post(apiEndpoints.requestOTP, data).then((res) => res.data),
    phoneFromIDBP: (params: object) =>
      axios.get(apiEndpoints.phoneFromIDBP, { params: params }).then((res) => res.data),
    requestOTPBP: (data: object) => axios.post(apiEndpoints.requestOTPBP, data).then((res) => res.data),
    loginWithOTP: (data: object) => axios.post(apiEndpoints.loginWithOTP, data).then((res) => res.data),
    loginWithOTPBP: (data: object) => axios.post(apiEndpoints.loginWithOTPBP, data).then((res) => res.data),
    forgotPassword: (data: object) => axios.post(apiEndpoints.forgotPassword, data).then((res) => res.data),
    resetPassword: (data: object) => axios.post(apiEndpoints.resetPassword, data).then((res) => res.data),
    changePassword: (data: object, signal: AbortSignal) =>
      axios.post(apiEndpoints.changePassword, (data = data), { signal: signal }).then((res) => res.data),
    policyStats: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.policyStats, { params: params, signal: signal }).then((res) => res.data),
    modifyProfile: (data: object) => axios.post(apiEndpoints.modifyProfile, data).then((res) => res.data),
    getOrgDetails: (id: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.orgDetails + id, { signal: signal }).then((res) => res.data),
    checkSSO: (params: object) => axios.get(apiEndpoints.checkSSO, { params: params }).then((res) => res.data),
    getModificationTracking: (params: object) =>
      axios.get(apiEndpoints.modificationTracker, { params: params }).then((res) => res.data),
    cancelEndorsement: (data: object) => axios.post(apiEndpoints.cancelEndorsement, data).then((res) => res.data),
    getNomineeDetails: (params?: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.nomineeDetails, { params: params, signal: signal }).then((res) => res.data),
    updateNomineeDetails: (data: object, params?: object) =>
      axios.put(apiEndpoints.nomineeDetails, data, { params: params }).then((res) => res.data),
    createNomineeDetails: (data: object, params?: object) =>
      axios.post(apiEndpoints.nomineeDetails, data, { params: params }).then((res) => res.data),
    getConfirmationStatus: (params?: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.profileConfirmation, { params: params, signal: signal }).then((res) => res.data),
    confirmDetails: (data: object) => axios.post(apiEndpoints.profileConfirmation, data).then((res) => res.data),
  },
  hubble: {
    createSsoToken: (signal?: AbortSignal) =>
      axios.post(apiEndpoints.hubbleSsoToken, undefined, { signal }).then((res) => res.data),
  },
  members: {
    getEmployerOrganisationProducts: (organisationUuid: string, signal?: AbortSignal) =>
      axios.get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/products/`, { signal }).then((res) => res.data),
    getEmployerBanners: (organisationUuid: string, signal?: AbortSignal) =>
      axios.get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/banners/`, { signal }).then((res) => res.data),
    requestEmployerMemberMIS: (data: object) => axios.post(apiEndpoints.employerMemberMIS, data).then((res) => res.data),
    startEmployerMisValidation: (organisationUuid: string, data: FormData) =>
      axios.post(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis/validate/`, data).then((res) => res.data),
    getEmployerMisValidationStatus: (organisationUuid: string, taskId: string, signal?: AbortSignal) =>
      axios.get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis-validate/task-status/${taskId}/`, { signal }).then((res) => res.data),
    getEmployerMisValidationRows: (organisationUuid: string, batchId: string, params: object, signal?: AbortSignal) =>
      axios.get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis-validate/${batchId}/rows/`, { params, signal }).then((res) => res.data),
    updateEmployerMisValidationRow: (organisationUuid: string, batchId: string, rowIndex: number, data: object) =>
      axios.patch(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis/validate/${batchId}/rows/${rowIndex}/`, data).then((res) => res.data),
    deleteEmployerMisValidationRow: (organisationUuid: string, batchId: string, rowIndex: number) =>
      axios.delete(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis/validate/${batchId}/rows/${rowIndex}/`).then((res) => res.data),
    bulkDeleteEmployerMisValidationRows: (organisationUuid: string, batchId: string, rowIndexes: number[]) =>
      axios.post(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis/validate/${batchId}/rows/bulk-delete/`, { row_indexes: rowIndexes }).then((res) => res.data),
    rerunEmployerMisValidation: (organisationUuid: string, batchId: string, data: object) =>
      axios.post(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis/validate/${batchId}/run/`, data).then((res) => res.data),
    applyEmployerMis: (organisationUuid: string, data: object) =>
      axios.post(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/mis/apply/`, data).then((res) => res.data),
    generateEmployerPolicyEcard: (organisationUuid: string, policyUuid: string, data: object) =>
      axios.post(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/policies/${policyUuid}/ecards/bulk/`, data).then((res) => res.data),
    inviteEmployerMember: (organisationUuid: string, data: object) =>
      axios.post(`${apiEndpoints.employerInvite}${organisationUuid}/members/invite/`, data).then((res) => res.data),
    reviewEmployerInvites: (organisationUuid: string, data: object) =>
      axios.post(`${apiEndpoints.employerInvite}${organisationUuid}/members/invite/review/`, data).then((res) => res.data),
    bulkInviteEmployerMembers: (organisationUuid: string, data: object) =>
      axios.post(`${apiEndpoints.employerInvite}${organisationUuid}/members/invite/bulk/`, data).then((res) => res.data),
    getEmployerMemberLinkedPolicies: (organisationUuid: string, memberUuid: string, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/members/${memberUuid}/linked-policies/`, { signal })
        .then((res) => res.data),
    getEmployerMemberDetails: (organisationUuid: string, memberUuid: string, params: object, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/members/${memberUuid}/`, { params, signal })
        .then((res) => res.data),
    updateEmployerMemberPersonal: (organisationUuid: string, memberUuid: string, data: object) =>
      axios.patch(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/members/${memberUuid}/personal/`, data).then((res) => res.data),
    createEmployerMemberDependentV1: (organisationUuid: string, memberUuid: string, data: object) =>
      axios.post(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/members/${memberUuid}/dependents/`, data).then((res) => res.data),
    updateEmployerMemberProduct: (organisationUuid: string, memberUuid: string, data: object) =>
      axios.patch(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/members/${memberUuid}/product/`, data).then((res) => res.data),
    removeEmployerMemberProduct: (organisationUuid: string, memberUuid: string, data: object) =>
      axios.delete(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/members/${memberUuid}/product/`, { data }).then((res) => res.data),
    updateEmployerMemberContacts: (organisationUuid: string, memberUuid: string, data: object) =>
      axios.patch(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/members/${memberUuid}/contacts/`, data).then((res) => res.data),
    getEmployerPolicyMembers: (organisationUuid: string, policyUuid: string, params: object, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/policies/${policyUuid}/members/`, {
          params,
          paramsSerializer: { indexes: null },
          signal,
        })
        .then((res) => res.data),
    getEmployerSubscriptionMembers: (organisationUuid: string, subscriptionUuid: string, params: object, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employerOrganisationProducts}${organisationUuid}/subscriptions/${subscriptionUuid}/members/`, {
          params,
          paramsSerializer: { indexes: null },
          signal,
        })
        .then((res) => res.data),
    getMember: (params: object, signal?: AbortSignal) =>
      axios
        .get(apiEndpoints.membersV2, {
          params: params,
          paramsSerializer: {
            indexes: null,
          },
          signal: signal,
        })
        .then((res) => res.data),
    getSingleMember: (id: any, params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.members + '/' + id, { params: params, signal: signal }).then((res) => res.data),
    updateMember: (id: any, data: any) =>
      axios.put(apiEndpoints.members + '/' + id, (data = data)).then((res) => res.data),
    createMember: (data: object) => axios.post(apiEndpoints.members, data).then((res) => res.data),
    createMemberV1: (data: object) => axios.post(apiEndpoints.membersV1, data).then((res) => res.data),
    updateMemberV1: (data: any) => axios.put(apiEndpoints.membersV1, (data = data)).then((res) => res.data),
    addProducts: (data: object) => axios.post(apiEndpoints.addProducts, data).then((res) => res.data),
    removeMember: (data: object) => axios.post(apiEndpoints.memberRemove, data).then((res) => res.data),
    removeDependant: (data: object) => axios.post(apiEndpoints.dependantRemove, data).then((res) => res.data),
    removeMemberFromAllV1: (organisationUuid: string, data: object) =>
      axios.delete(apiEndpoints.removeMemberFromAllV1(organisationUuid), { data }).then((res) => res.data),
    organisationMIS: (data: object) => axios.post(apiEndpoints.organisationMIS, data).then((res) => res.data),
    clientLoginData: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.clientLoginData, { params: params, signal: signal }).then((res) => res.data),
    getUploadTemplate: (params: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.uploadTemplate, { params: params, signal: signal }).then((res) => res.data),
    memberDataReview: (data: any) => axios.post(apiEndpoints.memberDataReview, (data = data)).then((res) => res.data),
    memberDataSubmit: (data: any) => axios.post(apiEndpoints.memberDataSubmit, (data = data)).then((res) => res.data),
    memberDataDelete: (data: any) => axios.post(apiEndpoints.memberDataDelete, (data = data)).then((res) => res.data),
    bulkInviteMembers: (data: any) => axios.post(apiEndpoints.bulkInviteMembers, (data = data)).then((res) => res.data),
    getModificationRequests: (params: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.getModificationRequests, { params: params, signal: signal }).then((res) => res.data),
    getModificationCount: (params: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.getModificationCount, { params: params, signal: signal }).then((res) => res.data),
    inviteMemberDetails: (data: any) =>
      axios.post(apiEndpoints.inviteMemberDetails, (data = data)).then((res) => res.data),
    inviteMemberDetailsV1: (data: any) =>
      axios.post(apiEndpoints.inviteMembersV1, (data = data)).then((res) => res.data),
    invitedMemberDetails: (id: any, data: any) =>
      axios.put(apiEndpoints.inviteMemberDetails + `/${id}`, (data = data)).then((res) => res.data),
    inviteMemberProducts: (data: any) =>
      axios.post(apiEndpoints.inviteMemberProducts, (data = data)).then((res) => res.data),
    getInvitedMemberDetails: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.invitedMemberDetails, { params: params, signal: signal }).then((res) => res.data),
    getCoverageType: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.checkCoverageType, { params: params, signal: signal }).then((res) => res.data),
    resendInvite: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.resendInvite, { params: params, signal: signal }).then((res) => res.data),
    updateMemberDetails: (data: any) =>
      axios.post(apiEndpoints.updateSelfDetails, (data = data)).then((res) => res.data),
    getMemberProducts: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.selfProducts, { params: params, signal: signal }).then((res) => res.data),
    updateMemberProducts: (data: any) => axios.post(apiEndpoints.selfProducts, (data = data)).then((res) => res.data),
    hardDelete: (data: any) => axios.post(apiEndpoints.hardDeleteMember, (data = data)).then((res) => res.data),
    hardDeleteEmployeeMember: (data: any) =>
      axios.post(apiEndpoints.hardDeleteMemberEmployee, (data = data)).then((res) => res.data),
    employeeRequestAction: (data: any) =>
      axios.post(apiEndpoints.getModificationRequests, (data = data)).then((res) => res.data),
    getEcard: (data: object) => axios.post(apiEndpoints.employerGenerateEcard, data).then((res) => res.data),
    getNomineeDetailsEmployer: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.nomineeDetailsEmployer, { params: params, signal: signal }).then((res) => res.data),
    createNomineeDetailsEmployer: (data: object, params?: object) =>
      axios.post(apiEndpoints.nomineeDetailsEmployer, data, { params: params }).then((res) => res.data),
    getNomineeMIS: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.nomineeMIS, { params: params, signal: signal }).then((res) => res.data),
  },
  products: {
    getProducts: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.products, { params: params, signal: signal }).then((res) => res.data),
    selectChoices: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.selectChoices, { params: params, signal: signal }).then((res) => res.data),
    getProductBenefit: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.productBenefit, { params: params, signal: signal }).then((res) => res.data),
    getStepsToAvail: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.stepsToAvail, { params: params, signal: signal }).then((res) => res.data),
    getCouponCode: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.generateCoupon, { params: params, signal: signal }).then((res) => res.data),
    activatePlan: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.activatePlan, { params: params, signal: signal }).then((res) => res.data),
    getPolicyDocuments: (id: number | string, params?: any) =>
      axios.get(apiEndpoints.policyDocuments + '?id=' + id, { params: params }).then((res) => res.data),
  },
  claims: {
    getClaims: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.getClaims, { params: params, signal: signal }).then((res) => res.data),
    getSingleClaim: (id: any, params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.getClaims + '/' + id, { params: params, signal: signal }).then((res) => res.data),
    claimStats: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.claimStats, { params: removeEmpty(params), signal: signal }).then((res) => res.data),
    getDocuments: (params: object) =>
      axios.get(apiEndpoints.claimDocuments, { params: params }).then((res) => res.data),
    getDocumentsV1: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.claimDocumentsV1, { params: params, signal: signal }).then((res) => res.data),
    claimConfig: (data: any, signal?: AbortSignal) =>
      axios.post(apiEndpoints.claimConfig, (data = data), { signal: signal }).then((res) => res.data),
    syncClaims: (data: any) => axios.post(apiEndpoints.claimSync, (data = data)).then((res) => res.data),
    getApiFields: (data: any) => axios.post(apiEndpoints.claimsApiFieldsConfig, (data = data)).then((res) => res.data),
    createClaim: (data: any) => axios.post(apiEndpoints.createClaim, (data = data)).then((res) => res.data),
    getClaimInfo: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.claimInfo, { params: params, signal: signal }).then((res) => res.data),
    editDocumentV1: (id: number, data: any) =>
      axios.put(apiEndpoints.claimDocumentsV1 + '/' + id, (data = data)).then((res) => res.data),
    postDocumentsV1: (data: any) => axios.post(apiEndpoints.claimDocumentsV1, (data = data)).then((res) => res.data),
    checkClaimAPIStatus: (params: any) => axios.get(apiEndpoints.checkClaimAPIStatus, { params: params }).then((res) => res.data),
  },
  employee: {
    getEmployeeMe: (organisationUuid: string, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employeeOrganisation}${organisationUuid}/me/`, { signal })
        .then((res) => res.data),
    getBanners: (organisationUuid: string, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employeeOrganisation}${organisationUuid}/banners/`, { signal })
        .then((res) => res.data),
    getEmployeeDetails: (params: any, signal?: AbortSignal) => {
      const orgUuid = typeof params === 'string' ? params : params?.organisation_uuid;
      if (orgUuid) {
        return axios
          .get(`${apiEndpoints.employeeOrganisation}${orgUuid}/me/`, { signal })
          .then((res) => res.data);
      }
      return axios.get(apiEndpoints.memberDetails, { params: params, signal: signal }).then((res) => res.data);
    },
    getEmployeePersonalDetails: (organisationUuid: string, memberUuid: string, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/personal/`, { signal })
        .then((res) => res.data),
    getEmployeeDependents: (organisationUuid: string, memberUuid: string, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/dependents/`, { signal })
        .then((res) => res.data),
    updateEmployeePersonalDetails: (organisationUuid: string, memberUuid: string, data: object) =>
      axios
        .patch(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/personal/`, data)
        .then((res) => res.data),
    getPersonalConfirmations: (organisationUuid: string, memberUuid: string, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/personal/confirm/`, {
          signal,
        })
        .then((res) => res.data),
    confirmPersonalDetails: (organisationUuid: string, memberUuid: string, data: object) =>
      axios
        .post(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/personal/confirm/`, data)
        .then((res) => res.data),
    getReviewAndFixOptions: (organisationUuid: string, memberUuid: string, field: string, signal?: AbortSignal) =>
      axios
        .get(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/personal/review-and-fix/`, {
          params: { field },
          signal,
        })
        .then((res) => res.data),
    previewReviewAndFix: (organisationUuid: string, memberUuid: string, data: object) =>
      axios
        .post(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/personal/review-and-fix/`, data)
        .then((res) => res.data),
    applyReviewAndFix: (organisationUuid: string, memberUuid: string, data: object) =>
      axios
        .post(`${apiEndpoints.employeeOrganisation}${organisationUuid}/members/${memberUuid}/personal/review-and-fix/apply/`, data)
        .then((res) => res.data),
    getClaims: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.employeeClaims, { params: params, signal: signal }).then((res) => res.data),
    getClaimDetails: (id: any, params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.employeeClaims + '/' + id, { params: params }).then((res) => res.data),
    getClaimStats: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.employeeClaimStats, { params: params, signal: signal }).then((res) => res.data),
    getProducts: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.employeeProducts, { params: params, signal: signal }).then((res) => res.data),
    getEcard: (data: object) => axios.post(apiEndpoints.generateEcard, data).then((res) => res.data),
  },
  UHI: {
    getFamilyMembers: (params: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.UHIFamilyListing, { params: params, signal: signal }).then((res) => res.data),
    editFamilyMember: (id: any, data: any) =>
      axios.patch(apiEndpoints.UHIFamilyListing + `/${id}`, (data = data)).then((res) => res.data),
    // validations: (data: any) => axios.get(apiEndpoints.UHIValidations, data = data).then((res) => res.data),
    validations: (params: any, signal?: AbortSignal) =>
      axios
        .get(apiEndpoints.UHIValidations, {
          params: params,
          paramsSerializer: {
            indexes: null,
          },
          signal: signal,
        })
        .then((res) => res.data),
    createUpgradeRequest: (data: any) =>
      axios.post(apiEndpoints.UHIFamilyListing, (data = data)).then((res) => res.data),
    UHIPremiumCalulator: (params: any) =>
      axios
        .get(apiEndpoints.UHIPremiumCalculator, {
          params: params,
          paramsSerializer: {
            indexes: null,
          },
        })
        .then((res) => res.data),
    additionalDetails: (data: object) => axios.post(apiEndpoints.UHIAdditionalDetails, data).then((res) => res.data),
    updateAdditionalDetails: (data: object, id: any) =>
      axios.put(apiEndpoints.UHIAdditionalDetails + '/' + id, data).then((res) => res.data),
    addMember: (data: object) => axios.post(apiEndpoints.UHIAddMember, data).then((res) => res.data),
    getAdditionalDetails: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.UHIAdditionalDetails, { params: params, signal: signal }).then((res) => res.data),
    getProposal: (params: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.UHIProposal, { params: params, signal: signal }).then((res) => res.data),
    checkProposal: (data: object) =>
      axios.post(apiEndpoints.UHIProposal, QueryString.stringify(data), configUrlEncoded).then((res) => res.data),
    getPaymentLink: (data: object) => axios.post(apiEndpoints.paymentRequest, data).then((res) => res.data),
    getPaymentStatus: (data: object) =>
      axios.post(apiEndpoints.retail_paymentStatus, qs.stringify(data), configUrlEncoded).then((res) => res.data),
    getPolicyDocs: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.UHIPolicyDocs, { params: params, signal: signal }).then((res) => res.data),
    test: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.UHIPolicyDocs, { params: params, signal: signal }).then((res) => res.data),
    selectChoices: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.UHIFilter, { params: params, signal: signal }).then((res) => res.data),
    applicationDetail: (params: any, signal?: AbortSignal) =>
      axios.get(apiEndpoints.UHIApplicationDetail, { params: params, signal: signal }).then((res) => res.data),
    renewalStatus: (params?: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.ftiRenewal, { params: params, signal: signal }).then((res) => res.data),
  },
  partner: {
    payments: {
      getFormPaymentOrder: (data: object) =>
        axios.post(apiEndpoints.form_payment_order, data).then((res) => res.data),
      verifyFormPaymentOrder: (data: object) =>
        axios.post(apiEndpoints.verify_form_payment_order, qs.stringify(data), configUrlEncoded).then((res) => res.data),
    }
  },
  broker: {
    getBrokerConfig: (params?: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.brokerConfig, { params: params, signal: signal }).then((res) => res.data),
    tripsafeSso: () =>
      axios.post(apiEndpoints.tripsafeSso, {}).then((res) => res.data),
    trackBannerClick: (uuid: string, data?: object) => axios.post(apiEndpoints.brokerBannerClick + uuid, data).then((res) => res.data),
  },
  hrms: {
    getTartanSessionToken: (signal?: AbortSignal) =>
      axios.post(apiEndpoints.tartanHrms, undefined, { signal }).then((res) => res.data),
    getTartanAppList: (signal?: AbortSignal) =>
      axios.get(apiEndpoints.tartanAppList, { signal }).then((res) => res.data),
    getTartanMemberList: (params?: object, signal?: AbortSignal) =>
      axios
        .get(apiEndpoints.tartanMemberList, {
          params: params,
          paramsSerializer: {
            indexes: null,
          },
          signal: signal,
        })
        .then((res) => res.data),
    updateTartanMember: (data?: any) => axios.put(apiEndpoints.tartanMemberList, data).then((res) => res.data),
    tartanStatusUpdate: (data?: any) => axios.post(apiEndpoints.tartanStatusUpdate, data).then((res) => res.data),
    tartanFilter: (data?: any, signal?: AbortSignal) =>
      axios.post(apiEndpoints.tartanFilter, data, { signal: signal }).then((res) => res.data),
    tartanProductSubscription: (data?: any) =>
      axios.post(apiEndpoints.tartanProductSubscription, data).then((res) => res.data),
    tartanConfig: (signal?: AbortSignal) => axios.get(apiEndpoints.tartanConfig, { signal }).then((res) => res.data),
    tartanDisconnect: (signal?: AbortSignal) =>
      axios.put(apiEndpoints.tartanConfig, undefined, { signal }).then((res) => res.data),
    getTartanAutomationSettings: (params: { organisation_uuid: string }, signal?: AbortSignal) =>
      axios.get(apiEndpoints.tartanAutomationSettings, { params, signal }).then((res) => res.data),
    updateTartanAutomationSettings: (data: any) =>
      axios.put(apiEndpoints.tartanAutomationSettings, data).then((res) => res.data),
    getTartanAutomationProductMappings: (params: { organisation_uuid: string }, signal?: AbortSignal) =>
      axios.get(apiEndpoints.tartanAutomationProductMappings, { params, signal }).then((res) => res.data),
    updateTartanAutomationProductMappings: (data: any) =>
      axios.put(apiEndpoints.tartanAutomationProductMappings, data).then((res) => res.data),
    getTartanAutomationMappingValues: (
      params: { organisation_uuid: string; basis: 'GRADE' | 'DESIGNATION' },
      signal?: AbortSignal
    ) => axios.get(apiEndpoints.tartanAutomationMappingValues, { params, signal }).then((res) => res.data),
    getTartanAutomationPreview: (data: any, signal?: AbortSignal) =>
      axios.post(apiEndpoints.tartanAutomationPreview, data, { signal }).then((res) => res.data),
    confirmTartanAutomationInvites: (data: any) =>
      axios.post(apiEndpoints.tartanAutomationConfirmInvites, data).then((res) => res.data),
  },
  orp: {
    listCatalogue: (params: object, signal?: AbortSignal) =>
      axios
        .get(apiEndpoints.orp.listCatalogue, {
          params: params,
          signal: signal,
        })
        .then((res) => res.data),
    listProductsWithPlans: (params: object, signal?: AbortSignal) =>
      axios
        .get(apiEndpoints.orp.listProductsWithPlans, {
          params: params,
          signal: signal,
        })
        .then((res) => res.data),
    listOffersWithRedemption: (params: object, signal?: AbortSignal) =>
      axios
        .get(apiEndpoints.orp.listOffersWithRedemption, {
          params: params,
          signal: signal,
        })
        .then((res) => res.data),
    getCoupon: (params: object) =>
      axios
        .get(apiEndpoints.orp.getCoupon, {
          params: params,
        })
        .then((res) => res.data),
  },
  notification: {
    getNotificationList: (params?: any) =>
      axios.get(apiEndpoints.notification, { params: params }).then((res) => res.data),
    updateNotification: (id: number, data: any) =>
      axios.put(apiEndpoints.notification + '/' + id, (data = data)).then((res) => res.data),
    updateAllNotifications: (data: any) => axios.post(apiEndpoints.notification, (data = data)).then((res) => res.data),
    getCount: () => axios.get(apiEndpoints.notificationCount).then((res) => res.data),
  },
  //retail
  // retail_user: {
  //   requestOTP: (data: any) => axios.post(apiEndpoints.retail_requestOTP, data).then((res) => res.data),
  //   verifyOTP: (data: any) => axios.post(apiEndpoints.retail_verifyOTP, data).then((res) => res.data),
  //   profile: () => axios.get(apiEndpoints.retail_userProfile).then((res) => res.data),
  //   updateProfile: (data: any) => axios.post(apiEndpoints.retail_userProfile, data).then((res) => res.data),
  //   getChoices: (params?: object) => axios.get(apiEndpoints.retail_filter, { params: params }).then((res) => res.data),
  // },
  // retail_partner: {
  //   getPartner: (params: object, cancelToken: any) =>
  //     axios
  //       .get(apiEndpoints.retail_getPartner, {
  //         params: params,
  //         paramsSerializer: (params) => {
  //           return qs.stringify(params, { arrayFormat: 'repeat' });
  //         },
  //         cancelToken: cancelToken,
  //       },
  //       )
  //       .then((res) => res.data),

  //   getProducts: (params: object, cancelToken: any) =>
  //     axios
  //       .get(apiEndpoints.retail_getProducts, {
  //         params: params,
  //         paramsSerializer: (params) => {
  //           return qs.stringify(params, { arrayFormat: 'repeat' });
  //         },
  //         cancelToken: cancelToken,
  //       })
  //       .then((res) => res.data),

  //   getProductsV2: (params: object, cancelToken?: any) =>
  //     axios
  //       .get(apiEndpoints.retail_plansAndOffers, {
  //         params: params,
  //         paramsSerializer: (params) => {
  //           return qs.stringify(params, { arrayFormat: 'repeat' });
  //         },
  //         cancelToken: cancelToken,
  //       })
  //       .then((res) => res.data),

  //   getSlugProductsV2: (params: object, cancelToken?: any) =>
  //     axios
  //       .get(apiEndpoints.retail_slugPlansAndOffers, {
  //         params: params,
  //         paramsSerializer: (params) => {
  //           return qs.stringify(params, { arrayFormat: 'repeat' });
  //         },
  //         cancelToken: cancelToken,
  //       })
  //       .then((res) => res.data),

  //   // getProductV2: (params?: object) => axios.get(apiEndpoints.manageCart, { params: params }).then((res) => res.data),
  //   redeemOffer: (data: object) => axios.post(apiEndpoints.retail_redeemOffer, data).then((res) => res.data),

  //   getPartnerDetails: (params?: object) => axios.get(apiEndpoints.retail_partnerDetails, { params: params }).then((res) => res.data),

  // },
  // retail_cart: {
  //   manageCart: (data: object) => axios.post(apiEndpoints.retail_manageCart, data).then((res) => res.data),
  //   clearCart: (id: number, params?: object) => axios.delete(apiEndpoints.retail_manageCart + `/${id}`, { params: params }).then((res) => res.data),
  //   getCart: (params?: object) => axios.get(apiEndpoints.retail_manageCart, { params: params }).then((res) => res.data),
  //   cartCount: (params?: object) => axios.get(apiEndpoints.retail_cartCount, { params: params }).then((res) => res.data),
  // },
  // retail_payments: {
  //   getPaymentLink: (data: object) => axios.post(apiEndpoints.retail_paymentRequest, data).then((res) => res.data),
  //   getPaymentStatus: (data: object) => axios.post(apiEndpoints.retail_paymentStatus, qs.stringify(data)).then((res) => res.data),
  // },
  // retail_coupons: {
  //   purchasedCoupons: (params: object) => axios.get(apiEndpoints.retail_purchasedCoupons, { params: params }).then((res) => res.data),
  // }
  multiEntityAccess: {
    getMultiEntityAccess: (params?: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.multiEntityAccess, { params: params || {}, signal: signal }).then((res) => res.data),
    switchToken: (data: object, signal?: AbortSignal) =>
      axios.post(apiEndpoints.switchToken, data, { signal: signal }).then((res) => res.data),
  },
  even: {
    getAuthToken: (params: object, signal?: AbortSignal) =>
      axios.get(apiEndpoints.evenAuthToken, { params: params, signal: signal }).then((res) => res.data),
  },
  dashboard: {
    dashboardActivity: (params?: object) =>
      axios.get(apiEndpoints.dashboardActivity, { params: params }).then((res) => res.data),
    dashboardEngagement: (params?: object) =>
      axios.get(apiEndpoints.dashboardEngagement, { params: params }).then((res) => res.data),
    // Returns full axios response (blob) so caller can read headers for filename
    downloadReport: (params?: object) =>
      axios.get(apiEndpoints.dashboardReportDownload, { params: params, responseType: 'blob' }).then((res) => res),
  },
  aira: {
    chat: (payload: { job_id: string; message: string; session_id?: string }, signal?: AbortSignal) => {
      const token = getAccessToken() || 'naqWktOwwK3HNdXZVkKQyuotz0zTX4';
      return axios
        .post(apiEndpoints.aiAgentChat, payload, {
          signal,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data);
    },
  },
};

export default api;
